import { Col, Typography } from 'antd';
import React from 'react';
import { ActiveChannels } from '../common/channelsEnum';
import { log } from './LogStreamTable';
import { NotificationDetailsStatus } from '../../interfaces/api/Logs';
import Paragraph from 'antd/es/typography/Paragraph';
import { SMSPreview } from '../notifications/tabs/sms/SMSPreview';
import moment from 'moment-timezone';
import 'moment-timezone';
import { InAppPreview } from '../notifications/tabs/inAppWeb/InAppPreview';
import { WebPushPreview } from '../notifications/tabs/webPush/WebPushPreview';
import { PushPreview } from '../notifications/tabs/push/PushPreview';
import Link from 'antd/es/typography/Link';
import { SenderPOSTRequest } from '../../interfaces/backend/SenderPOSTRequest';
export type IgnoredLogDetailsProps = {
  ignoredLog: log;
  timezone: string;
  receivedMessageBody: SenderPOSTRequest;
};
const { Text } = Typography;

const IgnoredLogDetails = ({
  ignoredLog,
  timezone,
  receivedMessageBody
}: IgnoredLogDetailsProps): JSX.Element => {
  console.log(ignoredLog);
  if (
    ignoredLog.message.status !== NotificationDetailsStatus.IGNORED ||
    !ignoredLog.message.template
  )
    return <></>;

  if (ignoredLog.message.template.channel === ActiveChannels.INAPP_WEB) {
    return (
      <InAppPreview
        title={ignoredLog.message.template?.title}
        imageURL={ignoredLog.message.template?.imageURL}
        redirectURL={ignoredLog.message.body?.redirectURL}
        time={new Date(ignoredLog.timestamp).toISOString()}
        uniqueId={ignoredLog.timestamp.toString()}
        disableClick={false}
      />
    );
  }

  if (ignoredLog.message.template.channel === ActiveChannels.SMS) {
    return (
      <SMSPreview
        text={ignoredLog.message.template.text}
        time={moment(ignoredLog.timestamp).tz(timezone).format('hh:mm A')}
      />
    );
  }

  if (ignoredLog.message.template.channel === ActiveChannels.EMAIL) {
    return (
      <Col>
        <div>
          <Text type="secondary">Subject: </Text>
          <Text>{ignoredLog.message.template.subject}</Text>
        </div>
        {receivedMessageBody && (
          <div>
            <div>
              <Text type="secondary">To: </Text>
              <Text>{receivedMessageBody.user.email}</Text>
            </div>
            {receivedMessageBody.options?.email?.ccAddresses && (
              <div>
                <Text type="secondary">CC: </Text>
                <Text>
                  {receivedMessageBody.options.email.ccAddresses.join(', ')}
                </Text>
              </div>
            )}
            {receivedMessageBody.options?.email?.bccAddresses && (
              <div>
                <Text type="secondary">BCC: </Text>
                <Text>
                  {receivedMessageBody.options.email.bccAddresses.join(', ')}
                </Text>
              </div>
            )}
            {receivedMessageBody.options?.email?.attachments &&
              receivedMessageBody.options?.email?.attachments.length > 0 && (
                <>
                  <Text type="secondary">Attachments: </Text>

                  {ignoredLog.message.attachments?.map((a, i) => {
                    return (
                      <div key={i}>
                        <Link href={a.href} target="_blank">
                          {a.filename}
                        </Link>
                      </div>
                    );
                  })}
                </>
              )}
          </div>
        )}

        <iframe
          style={{
            border: 'none',
            resize: 'horizontal',
            maxWidth: '100%',
            marginTop: '16px'
          }}
          width="620px"
          title={ignoredLog.timestamp.toString()}
          onLoad={(event) => {
            const iframe = event.target as HTMLIFrameElement;
            iframe.width = iframe.contentDocument?.body.scrollWidth
              ? iframe.contentDocument?.body.scrollWidth + 20 + 'px'
              : '100%';
            iframe.height =
              (iframe.contentDocument?.body.scrollHeight
                ? iframe.contentDocument?.body.scrollHeight + 20
                : 1000
              ).toString() + 'px';
          }}
          srcDoc={ignoredLog.message.template.html}
        ></iframe>
      </Col>
    );
  }

  if (ignoredLog.message.template.channel === ActiveChannels.CALL) {
    return (
      <Col>
        <Paragraph>{ignoredLog.message.template.text}</Paragraph>
        <Paragraph type="secondary">- Read by a female robot voice</Paragraph>
      </Col>
    );
  }

  if (ignoredLog.message.template.channel === ActiveChannels.WEB_PUSH) {
    return (
      <WebPushPreview
        title={ignoredLog.message.template.title}
        message={ignoredLog.message.template.message}
        icon={ignoredLog.message.template.icon}
        url={ignoredLog.message.template.url}
        disableClick={false}
        time={moment(ignoredLog.timestamp).tz(timezone).format('hh:mm A')}
      />
    );
  }

  if (ignoredLog.message.template.channel === ActiveChannels.PUSH) {
    return (
      <PushPreview
        title={ignoredLog.message.template.title}
        message={ignoredLog.message.template.message}
        date={moment(ignoredLog.timestamp).tz(timezone).format('dddd, MMMM DD')}
        time={moment(ignoredLog.timestamp).tz(timezone).format('hh:mm ')}
      />
    );
  }

  window.Rollbar?.error('Unknown log in logs page', ignoredLog);
  return (
    <>
      {window.Rollbar && (
        <Text>
          Cannot generate preview. Our support team has been notified and will
          be working on resolving the issue shortly. We will be in touch with
          you through email.
        </Text>
      )}
      {!window.Rollbar && (
        <Text>
          Cannot generate preview. Please contact our support team to resolve
          the issue.
        </Text>
      )}
    </>
  );
};
export default IgnoredLogDetails;
